import { type ModalId } from '@heidi/schema/ml-scribe';

/**
 * Seen-state id for the one-time modal once a new user's Clinician trial has
 * ended. Cast until the generated schema carries the ml-scribe member; the
 * string is frozen (it keys `seen_modals`).
 */
export const CLINICIAN_TRIAL_ENDED_MODAL_ID =
  'CUSTOM_AUDIENCE_HEIDI_2_CLINICIAN_TRIAL_ENDED_MODAL' as ModalId;
